import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { theme } from 'theme'
import Grid from '@material-ui/core/Grid'
import Add from '@material-ui/icons/Add'
import { makeStyles } from '@material-ui/core/styles'
import PlayIcon from '@material-ui/icons/PlayArrow'
import Link from '@material-ui/core/Link'
import Snackbar from '@material-ui/core/Snackbar'
import Dialog from '@material-ui/core/Dialog'
import ActionButton from 'common-components/action-button/ActionButton'
import Loader from 'common-components/loader-overlay/loader-react'
import AppSelect from '../../../../components/AppSelect.js'
import NewResourceForm from '../../../../components/NewResourceForm.js'
import { getBaseUrl } from '../../../../global/config/providers/restangularProvider/rest.js'
import './calls.scss'
const slugify = require('slugify')
let Header
const API_BASE_URL = getBaseUrl(window.location.host, true)
const useStyles = makeStyles(theme => ({
  redirectLink: {
    cursor: 'pointer',
    color: '#1194f6',
  },
  dialer: {
    height: '55vh',
  },
  pStyled: {
    color: '#7c8a97',
    fontSize: 18,
    fontWeight: 'bold',
    margin: 0,
  },
  btn: {
    padding: '0px !important',
    fontSize: '14px !important',
    color: '#444851 !important',
    margin: '15px 0px !important',
    cursor: 'pointer',
    display: 'block',
  },
  container6: {
    marginBottom: 20,
    paddingRight: 30,
  },
}))
const calls = props => {
  const classes = useStyles()
  const [url, setUrl] = useState('/manage/audio/resources')
  const [uuid, setUuid] = useState('')
  const [resources, setResources] = useState(false)
  const [onHold, setOnHold] = useState('')
  const [newCall, setNewCall] = useState('')
  const [callEnded, setCallEnded] = useState('')
  const [data, setData] = useState([])
  const [showButtons, setShowButtons] = useState(false)
  const [open, setOpen] = useState(false)
  const [snackCreate, setSnackCreate] = useState(false)
  const [initState, setInitState] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [companySlug, setCompanySlug] = useState('')
  const [campaign, setCampaign] = useState('')
  const [showPlayer, setShowPlayer] = useState({
    onHold: false,
    newCall: false,
    callEnded: false,
  })
  const [addDialogOpen, setAddDialogOpen] = useState(false)
  const redirectAudio = () => (window.location.href = url)
  const handleCancel = () => {
    let element = document.getElementById('divButtons')
    element.classList.add('fade-out')
    //set initial values for dropdowns
    initState.music_on_hold_pitch
      ? setOnHold(
          data.find(
            audio => slugify(audio.name, '_') === initState.music_on_hold_pitch,
          ),
        )
      : setOnHold('')
    initState.new_call_sound_pitch
      ? setNewCall(
          data.find(
            audio =>
              slugify(audio.name, '_') === initState.new_call_sound_pitch,
          ),
        )
      : setNewCall('')
    initState.call_ended_sound_pitch
      ? setCallEnded(
          data.find(
            audio =>
              slugify(audio.name, '_') === initState.call_ended_sound_pitch,
          ),
        )
      : setCallEnded('')
    setTimeout(function() {
      setShowButtons(false)
    }, 500)
  }
  const handleSave = () => {
    const queue = {
      music_on_hold_pitch: onHold.name ? slugify(onHold.name, '_') : null,
      new_call_sound_pitch: newCall.name ? slugify(newCall.name, '_') : null,
      call_ended_sound_pitch: callEnded.name
        ? slugify(callEnded.name, '_')
        : null,
    }
    axios
      .patch(`${API_BASE_URL}/identity/campaign/${uuid}/`, { queue })
      .then(res => {
        let element = document.getElementById('divButtons')
        element.classList.add('fade-out')
        setOpen(true)
        setInitState(res.data.queue)
        setTimeout(function() {
          setShowButtons(false)
        }, 500)
      })
      .catch(err => console.log(err))
  }
  const handlerPlayer = (type, value) => {
    let temp = { ...showPlayer }
    temp[type] = value
    setShowPlayer(temp)
  }
  const handleClose = () => {
    setOpen(false)
    setSnackCreate(false)
  }
  const handleOpenDialog = () => setAddDialogOpen(true)
  const cancelAddDialog = () => setAddDialogOpen(false)
  const updateResources = newItem => {
    setSnackCreate(true)
    setAddDialogOpen(false)
    setResources(false)
    setIsLoading(true)
    getData(companySlug, campaign)
  }
  useEffect(() => {
    if (window.location.origin.includes('localhost')) {
      setUrl('/#!/manage/audio/resources')
    }
    Header = {
      headers: {
        Authorization: `token ${JSON.parse(localStorage['ngStorage-ppToken'])}`,
      },
    }
    setTimeout(function() {
      getCampaign()
    }, 1000)
  }, [])
  const getCampaign = () => {
    let url = window.location.href.split('edit/')
    let camp = url[1].split('/')
    const slug = camp[0]
    axios
      .get(`${API_BASE_URL}/identity/campaign/list/?slug=${slug}`, Header)
      .then(res => {
        if (res.data[0].queue !== null) setInitState(res.data[0].queue)
        setUuid(res.data[0].uuid)
        setCampaign(res.data[0])
        getCompany(res.data[0])
      })
      .catch(err => console.log(err))
  }
  const getCompany = campaign => {
    axios
      .get(`${API_BASE_URL}/identity/company/${campaign.company}/`, Header)
      .then(res => {
        setCompanySlug(res.data.slug)
        getData(res.data.slug, campaign)
      })
      .catch(err => console.log(err))
  }
  const getData = (companySlug, campaign) => {
    axios
      .get(
        `${API_BASE_URL}/pitch/company/${companySlug}/audio/resources/`,
        Header,
      )
      .then(res => {
        if (res.data.length > 0) {
          if (campaign.queue !== null) {
            //set initial values for dropdowns
            if (campaign.queue.music_on_hold_pitch)
              setOnHold(
                res.data.find(
                  audio =>
                    slugify(audio.name, '_') ===
                    campaign.queue.music_on_hold_pitch,
                ),
              )
            if (campaign.queue.new_call_sound_pitch)
              setNewCall(
                res.data.find(
                  audio =>
                    slugify(audio.name, '_') ===
                    campaign.queue.new_call_sound_pitch,
                ),
              )
            if (campaign.queue.call_ended_sound_pitch)
              setCallEnded(
                res.data.find(
                  audio =>
                    slugify(audio.name, '_') ===
                    campaign.queue.call_ended_sound_pitch,
                ),
              )
          }
          setData(res.data)
          setResources(true)
        }
        setIsLoading(false)
      })
      .catch(err => console.log(err))
  }
  const PlayButton = props => {
    return (
      <Link
        className={props.classes.btn}
        onClick={() => props.switch(props.nameControl, !props.showPlayer)}
      >
        {props.showPlayer ? (
          <span style={{ textDecoration: 'underline' }}>Close</span>
        ) : (
          <React.Fragment>
            <PlayIcon style={{ fontSize: '14px', marginRight: 8 }} />{' '}
            <span style={{ textDecoration: 'underline' }}>
              Click to play audio
            </span>
          </React.Fragment>
        )}
      </Link>
    )
  }
  const SelectAudioList = props => {
    return (
      <div>
        <AppSelect
          label={props.label}
          keyName={'uuid'}
          data={props.data}
          displayName={'name'}
          item={props.item}
          onChange={item => (props.setItem(item), setShowButtons(true))}
          helpText={
            props.item !== '' &&
            props.item.file !== null &&
            'name' in props.item ? (
              <PlayButton
                classes={classes}
                showPlayer={props.showPlayer}
                nameControl={props.objectName}
                switch={(type, value) => props.switch(type, value)}
              />
            ) : (
              'No audio resource'
            )
          }
        />
        {props.showPlayer && props.item.file !== null && (
          <audio
            controls
            style={{ width: '100%' }}
            src={props.item.file.processed_url}
          >
            Your browser does not support the
            <code>audio</code> element.
          </audio>
        )}
      </div>
    )
  }

  return (
    <MuiThemeProvider theme={theme}>
      {isLoading ? (
        <React.Fragment>
          <Loader message="One moment. We're loading the data..." />
        </React.Fragment>
      ) : (
        <MuiThemeProvider theme={theme}>
          {!resources ? (
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="center"
              className={classes.dialer}
            >
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <p className={classes.pStyled}>
                  There is no calls resources yet
                </p>
                <p className="grey-text">
                  To add or edit company audio resources just hit the button
                  "Add resources"
                </p>
                <br />
                <ActionButton handleClick={redirectAudio}>
                  <Add style={{ fontSize: 20, marginRight: 5 }} /> Add resources
                </ActionButton>
              </Grid>
            </Grid>
          ) : (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ paddingLeft: 5 }}
            >
              <Grid item xs={12}>
                <p style={{ color: '#444851', marginTop: '25px' }}>
                  To add company audio resources click{' '}
                  <span
                    className={classes.redirectLink}
                    onClick={handleOpenDialog}
                  >
                    <Add style={{ fontSize: 15 }} />
                    Add new resource
                  </span>
                </p>
              </Grid>
              <Grid item xs={6} className={classes.container6}>
                <SelectAudioList
                  label={'Music on hold'}
                  data={data}
                  item={onHold}
                  objectName={'onHold'}
                  setItem={item => setOnHold(item)}
                  showPlayer={showPlayer.onHold}
                  switch={(type, value) => handlerPlayer(type, value)}
                />
              </Grid>
              <Grid item xs={6}></Grid>
              <Grid item xs={6} className={classes.container6}>
                <SelectAudioList
                  label={'New call sound'}
                  data={data}
                  item={newCall}
                  objectName={'newCall'}
                  setItem={item => setNewCall(item)}
                  showPlayer={showPlayer.newCall}
                  switch={(type, value) => handlerPlayer(type, value)}
                />
              </Grid>
              <Grid item xs={6}></Grid>
              <Grid item xs={6} className={classes.container6}>
                <SelectAudioList
                  label={'Call ended sound'}
                  data={data}
                  item={callEnded}
                  objectName={'callEnded'}
                  setItem={item => setCallEnded(item)}
                  showPlayer={showPlayer.callEnded}
                  switch={(type, value) => handlerPlayer(type, value)}
                />
              </Grid>
              <Grid item xs={6}></Grid>
              {showButtons && (
                <Grid item xs={12} id="divButtons">
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid item xs={1} style={{ textAlign: 'right' }}>
                      <ActionButton
                        handleClick={handleSave}
                        buttonColor="secondary"
                      >
                        SAVE
                      </ActionButton>
                    </Grid>
                    <Grid item xs={2} style={{ textAlign: 'right' }}>
                      <ActionButton
                        handleClick={handleCancel}
                        buttonColor="default"
                      >
                        CANCEL
                      </ActionButton>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}
          <Dialog
            className="newResourceModal"
            open={addDialogOpen}
            onClose={cancelAddDialog}
            maxWidth="xs"
            fullWidth={false}
            aria-labelledby="add-resource-dialog"
          >
            <NewResourceForm
              companySlug={companySlug}
              handleCreate={updateResources}
              handleCancel={cancelAddDialog}
            />
          </Dialog>
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            open={snackCreate}
            autoHideDuration={3000}
            onClose={handleClose}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">New resource has been created</span>}
          />
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">Changes have been saved</span>}
          />
        </MuiThemeProvider>
      )}
    </MuiThemeProvider>
  )
}
export default calls
